<template>
  <div class="leftres">
    <div>
      <div class="inputtop">
          <Commondropdownlist v-for="(item, index) of formdata" :key="index" ref="select" :lablewith="item.lablewith" :options="item.options"
            :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
            :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width">
          </Commondropdownlist>
        <div style="display: inline-block;float: right;margin-right: -10px;">
          <CommonBtngroup :show="showorhide" @showclick="showclick" @hide="hide" :qhide="false" @select="select"
            @reset="reset">
          </CommonBtngroup>
        </div>
        <div style="height:10px;">
        </div>
      </div>
      <div class="TableBox" style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); background-color: #FFFFFF; padding-bottom: 80px;">
        <FAQTable :loading="loading" :tableData="tabledata" :total="total" @refresh="getData" @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"></FAQTable>
      </div>
    </div>
  </div>
</template>

<script>
import Commondropdownlist from '../../../components/common-dropdownlist.vue'
import CommonBtngroup from '../../../components/commongroup.vue'
import FAQTable from './components/FAQTable.vue'
import { FAQList } from '@/api/faq'

export default {
  components: {
    Commondropdownlist,
    CommonBtngroup,
    FAQTable
  },
  data() {
    return {
      showorhide: false,
      pageSize: 20,
      pageIndex: 1,
      total: 0,
      loading: false,
      formdata: [
        {
          inputdata: "",
          title: '标题',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入标题',
          types: 'text',
          inputtype: 'input',
          width: '220px',
          modelvalue: ''
        },
        {
          inputdata: "",
          title: '创建时间',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请选择时间',
          types: 'date',
          inputtype: 'date',
          width: '220px',
          modelvalue: ''
        }
      ],
      tabledata: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      
      let title = ''
      if (this.$refs.select && this.$refs.select[0]) {
        title = this.$refs.select[0].modelvalue
      }

      let startTime = ''
      let endTime = ''
      if (this.$refs.select && this.$refs.select[1]) {
        startTime = this.$refs.select[1].startTime
        endTime = this.$refs.select[1].endTime
      }

      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        Title: title,
        CreateTime1: startTime,
        CreateTime2: endTime
      }

      try {
        const res = await FAQList(params)
        if (res.code === 0) {
          this.tabledata = res.data.data || [] // Assuming standard response structure
          this.total = res.data.Count || 0
        } else {
          this.$message.warning(res.message)
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },

    select() {
      this.pageIndex = 1
      this.getData()
    },

    reset() {
      this.formdata.forEach(item => item.modelvalue = '')
      if (this.$refs.select && this.$refs.select[0]) {
        this.$refs.select[0].modelvalue = ''
      }
      if (this.$refs.select && this.$refs.select[1]) {
        this.$refs.select[1].startTime = ''
        this.$refs.select[1].endTime = ''
      }
      this.select()
    },

    handleCurrentChange(val) {
      this.pageIndex = val
      this.getData()
    },

    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },

    showclick() {
      this.showorhide = true
    },

    hide() {
      this.showorhide = false
    }
  }
}
</script>

<style lang="less" scoped>
.inputtop {
  width: 980px;
  // height: 0px; 
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 15px;
  padding-bottom: 20px; // Adjusted
  // animation: shows 0.2s ease-in;
  overflow: hidden;
  margin-bottom: 10px;
}
</style>
